import { useEffect } from 'react';
import { ColumnsType, DeleteIcon } from '@/components/_common';
import {
  useAuthorizationDownloadXml,
  useDeleteAuthorizationDownloadXml,
} from '@/core/domain/invoice/settings/Settings.hooks';
import { AuthorizationDownloadXmlRequestDTO } from '@/core/domain/invoice/settings/Settings.types';
import { useDisclosure } from '@/hooks';
import { Button, Col, Form, Modal, Row, Space, Table } from 'antd';
import { cnpjMask, cpfMask } from '@/utils/mask/commonMasks';
import { applyMask } from '@/utils/mask';
import AuthorizationDownloadXmlModal from './AuthorizationDownloadXmlModal';

interface Props {
  invoiceSettingsId?: number;
}

const AuthorizationDownloadXmlForm = ({ invoiceSettingsId }: Props) => {
  const [form] = Form.useForm<AuthorizationDownloadXmlRequestDTO>();

  const authorizationDelete = useDeleteAuthorizationDownloadXml(invoiceSettingsId);

  const { data, isLoading } = useAuthorizationDownloadXml(
    invoiceSettingsId
  );

  const [modalVisible, modalVisibleAction] = useDisclosure();

  const selectCpfCnpjWatch = Form.useWatch('selectCpfCnpj', form);

  useEffect(() => {
    form.setFieldValue('cpfCnpj', '');
  }, [selectCpfCnpjWatch]);

  const handleRemoveClick = (
    authorization: AuthorizationDownloadXmlRequestDTO,
  ) => {
    Modal.confirm({
      title: 'Deseja realmente excluir a Autorização para baixar xml?',
      content: `Ao remover a a Autorização para baixar xml, a recuperação da mesma não poderá ser feita. Ainda sim deseja coninuar?`,
      onOk: async () => {
        await authorizationDelete.mutateAsync(Number(authorization?.id));
      },
      okType: 'danger',
    });
  };

  const columns: ColumnsType<AuthorizationDownloadXmlRequestDTO> = [
    {
      key: 'cpfCnpj',
      dataIndex: 'cpfCnpj',
      title: 'CpfCnpj',
      render: (_, row) => {
        if (row.cpfCnpj?.length === 11) return applyMask(row.cpfCnpj, cpfMask);

        if (row.cpfCnpj?.length === 14) return applyMask(row.cpfCnpj, cnpjMask);
      },
    },
    {
      key: 'email',
      dataIndex: 'email',
      title: 'Email',
    },
    {
      key: 'action',
      align: 'right',
      width: 100,
      render: (_, row) => (
        <Space>
          <DeleteIcon onClick={() => handleRemoveClick(row)} />
        </Space>
      ),
    },
  ];

  return (
    <>
      <Row justify="end">
        <Col>
          <Button type="primary" onClick={modalVisibleAction.toggle}>
            Cadastrar autorização
          </Button>
        </Col>

        <Col span={24}>
          <Table<AuthorizationDownloadXmlRequestDTO>
            pagination={false}
            loading={isLoading}
            columns={columns}
            dataSource={data}
          />
        </Col>
      </Row>

      <AuthorizationDownloadXmlModal
        form={form}
        modalVisible={modalVisible}
        invoiceSettingsId={invoiceSettingsId}
        modalVisibleAction={modalVisibleAction.toggle}
      />
    </>
  );
};

export default AuthorizationDownloadXmlForm;
